module.exports = __webpack_public_path__ + "static/media/geometric-leatherworking-tool.12549200.webp";